import './DetailSection.scss';
import classNames from 'classnames';
import { Row } from 'antd';
import { When } from 'react-if';
import React from 'react';
export const DetailSection = ({ children, className, headerAction, spacing = 'medium', title }) => React.createElement("div", { className: classNames('detail-section', className) },
    React.createElement(When, { condition: Boolean(title) || Boolean(headerAction) },
        React.createElement("div", { className: 'h2 detail-section-header' },
            React.createElement(Row, { className: 'h2', justify: 'space-between' },
                title,
                headerAction))),
    React.createElement("div", { className: classNames('detail-section-body', {
            'detail-section-body-large-spacing': spacing === 'large',
            'detail-section-body-no-spacing': spacing === 'none',
            'detail-section-body-small-spacing': spacing === 'small'
        }) }, children));
